import React from "react";
import Overlay from "./Overlay";

const SidePanel = ({ isOpen, onClose, children, className = "" }) => (
  <>
    <Overlay isOpen={isOpen} onClick={onClose} />
    <div className={`side-panel ${className} ${isOpen ? "open" : ""}`.trim()}>
      <div className="panel-content">
        <button className="close-btn" onClick={onClose}>×</button>
        {children}
      </div>
    </div>
  </>
);

export default SidePanel;
